import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  ChartArea,
  ScriptableContext,
} from 'chart.js';
import { colors } from 'utils/constants';
import { TimelineChartDataSet } from './types';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
);

/**
 * NOTE: Based on the example here:
 * https://www.chartjs.org/docs/latest/samples/advanced/linear-gradient.html
 */

let width = 0;
let height = 0;
let gradient: any;

function getGradient(ctx: CanvasRenderingContext2D, chartArea: ChartArea): any {
  const chartWidth = chartArea.right - chartArea.left;
  const chartHeight = chartArea.bottom - chartArea.top;
  if (!gradient || width !== chartWidth || height !== chartHeight) {
    width = chartWidth;
    height = chartHeight;
    gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
    gradient.addColorStop(0, colors.odinGrape100);
    gradient.addColorStop(1, colors.odinGrape300);
  }

  return gradient;
}

const dataSetDefaults = {
  backgroundColor: (context: ScriptableContext<'line'>): any => {
    const { chart } = context;
    const { ctx, chartArea } = chart;

    if (!chartArea) {
      return colors.odinGrape300;
    }

    /* eslint-disable-next-line */
    return getGradient(ctx, chartArea);
  },
  borderColor: colors.odinGrape500,
  fill: true,
};

const options = {
  responsive: true,
  maintainAspectRatio: false,
  scales: { y: { display: false }, x: { display: false } },
};

/**
 * Timeline slot content
 *
 * Creates a line graph to visualize a timeline of data. Note that the number of data points should
 * match the unitCount of the timeline (or subdivisions thereof) in order for data to match the ruler scales
 */
export function TimelineChart(props: {
  data: TimelineChartDataSet[];
}): React.ReactElement {
  const { data } = props;
  return (
    <div className="odin-relative odin-w-full odin-h-[64px]">
      <Line
        options={options}
        data={{
          labels: data.map((item) => item.label),
          datasets: [
            {
              ...dataSetDefaults,
              data: data.map((item) => item.value),
            },
          ],
        }}
      />
    </div>
  );
}
